import type { ExtractedRepeaterItem } from "../types";

const asString = (value: unknown): string =>
  typeof value === "string" ? value : "";

/**
 * Normaliza a lista crua de um campo `repeater`.
 *
 * Diferente dos outros compostos, aqui **não há forma fixa**: os sub-campos são
 * definidos pelo racer, então cada item vira um mapa `id do sub-campo → valor`.
 * Quem descarta item incompleto é o CONSUMIDOR, que sabe quais sub-campos são
 * essenciais para o seu layout — o normalizador não tem como saber.
 *
 * A ordem é a de cadastro e é preservada.
 */
export function normalizeRepeater(value: unknown): ExtractedRepeaterItem[] {
  if (!Array.isArray(value)) return [];

  return value.flatMap((item, index) => {
    if (!item || typeof item !== "object") return [];
    const raw = item as Record<string, unknown>;

    const values: Record<string, string> = {};
    for (const [key, entry] of Object.entries(raw)) {
      if (key === "id") continue;
      values[key] = asString(entry);
    }

    const id = asString(raw.id);
    return [{ id: id !== "" ? id : `repeater-${index}`, values }];
  });
}
